<template>
    <div :class="colorFlag === true ? 'colorFlag' : ''">
        <el-upload v-if="newsFlag" :class='id'
            class="avatar-uploader"
            action=''
            :http-request='uploadRequest'
            :with-credentials= "true"
            :multiple='false'
            :headers="{'Authorization': this.$cookie.get('auth')}"
            :data="uploadData"
            name= 'xwPic'
            :show-file-list="false"
            :on-error="$errorImage"
            :before-upload="beforeUpload">
        </el-upload>
        <el-upload v-else
            class="avatar-uploader"
            action=''
            :http-request='uploadRequest'
            :with-credentials= "true"
            :multiple='false'
            :headers="{'Authorization': this.$cookie.get('auth')}"
            name= 'pic'
            :show-file-list="false"
            :on-error="$errorImage"
            :before-upload="beforeUpload">
        </el-upload>
        <quill-editor
            v-model="editContent"
            ref="myQuillEditor"
            :options="editorOption"
            @change="onEditorChange($event)"
            @ready="onEditorReady($event)">
        </quill-editor>
    </div>
</template>

<script>
import {quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  ['blockquote', 'code-block'],

  [{'header': 1}, {'header': 2}],               // custom button values
  [{'list': 'ordered'}, {'list': 'bullet'}],
  [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
  [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
  [{'direction': 'rtl'}],                         // text direction

  [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
  [{'header': [1, 2, 3, 4, 5, 6, false]}],

  [{'color': []}, {'background': []}],          // dropdown with defaults from theme
//   [{'font': []}],
  [{'align': []}],
  // ['link', 'image', 'video'],
  ['link', 'image'],

//   ['clean']                                         // remove formatting button
]
// 工具栏配置
const toolbarOptionsBill = [
  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  ['blockquote', 'code-block'],

  [{'header': 1}, {'header': 2}],               // custom button values
  [{'list': 'ordered'}, {'list': 'bullet'}],
  [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
  [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
  [{'direction': 'rtl'}],                         // text direction

  [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
  [{'header': [1, 2, 3, 4, 5, 6, false]}],

  [{'color': []}, {'background': []}],          // dropdown with defaults from theme
//   [{'font': []}],
  [{'align': []}],
  ['link', 'image',],
//   ['clean']                                         // remove formatting button
]
export default {
  props:['content', 'newsFlag', 'colorFlag', 'id', 'billFlag'],
    data () {
        let that = this;
        return {
            editContent: this.content,
            editorOption: {
                placeholder: '',
                theme:'snow',
                modules:{
                    toolbar:{
                        container: this.billFlag ? toolbarOptionsBill : toolbarOptions,
                        handlers:{
                            'image': function (value) {
                                if (value) {
                                    if(that.id == null){
                                       document.querySelector('.avatar-uploader input').click();
                                    } else {
                                       document.querySelector('.' + that.id + ' input').click();
                                    }
                                } else {
                                    this.quill.format('image', false);
                                }
                            }
                        }
                    }
                }
            },  // 富文本编辑配置
            uploadData: { // 上传图片的附加参数（水印）
                flag: 'xw'
            }
        }
    },
    watch:{
        content (val) {
            if(val === '') {
                this.editContent = '';
            } else {
                this.editContent = val.replace(/&lt;script&gt;/g, '').replace(/&lt;\/script&gt;/g, '');
            }
        }
    },
    computed: {
        editor() {
            return this.$refs.myQuillEditor.quill;
        }
    },
    created(){
        // console.log(toolbarOptions.push(1))
    },

    methods: {
        // 上传图片之前的回调函数
        beforeUpload(res, file) {
            console.log('上传图片之前')
        },
        // 上传图片成功之前的回调函数
        uploadSuccess(res, file) {
            this.editContent = this.editContent + '<img src='+res.msg+'>';
        },
        uploadRequest(option){
          const file = option.file
          const self = this
          return new Promise((resolve, reject) => {
            const date = self.$dateFormat(new Date(), 'yyyy-MM-dd') // 当前时间
            const dateTime = self.$dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
            let randomStr = self.$randomString(4)//  4位随机字符串
            const extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
            const fileWay = 'resource/image/'
            const fileName = fileWay + date + '/' + dateTime + '_' + randomStr + extensionName // 文件名字（相对于根目录的路径 + 文件名）
            // 执行上传
            self.$createOssClient().then(client => {
              // 异步上传,返回数据
              // resolve({
              //   fileName: file.name,
              //   fileUrl: fileName // 图片路径
              // })
              // 上传处理
              // 分片上传文件
              client.multipartUpload(fileName, file, {headers:{'Cache-Control':'public'}})
              .then((val) => {
                if (val.res.statusCode === 200) {
                    let url=''
                    if(option.filename==='xwPic'){
                        url= self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic
                    } else {
                        url= self.$GLOBAL.picFileUrl + val.name
                    }
                    //cdn预热
                    self.$cdnFun(url).then(res=>{
                      console.log(res)
                    })
                    this.editContent = this.editContent + '<img src='+url+'>';;
                  return val
                } else {
                  option.onError('上传失败1')
                }
              }, err => {
                console.log(err)
                option.onError('上传失败')
                reject(err)
              })
            })
          })
        },
        onEditorReady(){
        // _this.$emit('listenFuEdit', _this.editContent)

        },
        onEditorChange(){
            let _this = this;
            _this.$emit('listenContent', _this.editContent);
        }
    },
    components:{
        quillEditor
    }
};
</script>

<style lang="less">
.ql-editor{
    min-height: 3rem;
}
.ql-editing{
  z-index: 1001;
}
</style>



// WEBPACK FOOTER //
// src/components/editor.vue